'use strict';
import * as infoModalActions from '../actions/infoModalActions';

/** @type {RequirementsInfoModalState} */
export const initialState = {
  isShowingModal: false,
  model: {
    name: '',
    description: '',
  },
};

/**
 * @param {RequirementsInfoModalState} state
 * @param {ReduxAction<any>} action
 * @return {RequirementsInfoModalState}
 */
export function infoModal(state = initialState, action) {
  switch (action.type) {
    case infoModalActions.showModal.TYPE:
      return {
        ...state,
        isShowingModal: true,
        model: action.payload,
      };
    case infoModalActions.hideModal.TYPE:
      return initialState;
    default:
      return state;
  }
}

/**
 * @typedef {FilterData} RequirementsInfoModalState
 * @property {Boolean} isShowingModal
 * @property {String} name
 * @property {String} description
 */



// WEBPACK FOOTER //
// ./src/js/requirements/reducers/infoModalReducers.js